import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataCategoriesActions } from "./categories.actions";

// **************************************************************************
// CATEGORIES REDUCER
// **************************************************************************

const load = on(DataCategoriesActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        category: {
            ...state.data.category,
            categoriesLoading: true,
        },
    },
}));

const loadSuccess = on(DataCategoriesActions.loadSuccess, (state: ApplicationStore, { categories }) => ({
    ...state,
    data: {
        ...state.data,
        category: {
            ...state.data.category,
            categories,
            categoriesLoading: false,
        },
    },
}));

const loadFailure = on(DataCategoriesActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        category: {
            ...state.data.category,
            categoriesLoading: false,
        },
    },
}));

export const categoriesReducer = [load, loadSuccess, loadFailure];
